import { Box, Button, Typography } from "@mui/material";
import EmptyTemplate from "../../../../shared/assets/ilustrations/EmptyTemplates.png";

export default function ChannelsEmptyState({ onAdd }) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="90%">
      <Box sx={{ width: { xs: "80%", sm: "auto" } }}>
        <Box
          component="img"
          src={EmptyTemplate}
          alt="Sem canais"
          sx={{ width: { xs: "247px", sm: "494px" }, height: { xs: "165px", sm: "330px" } }}
        />

        <Box display="flex" flexDirection="column" gap={2} textAlign="center">
          
          {/* Título principal */}
          <Typography 
            variant="h4"
            fontWeight={700}
            color="#8033F4"
          >
            Parece que você não tem canais :(
          </Typography>

          {/* Descrição */}
          <Typography variant="body1" color="text.secondary">
            Adicione um agora mesmo, é fácil e rápido
          </Typography>

          {/* Botão */}
          <Button variant="contained" onClick={onAdd}>
            Adicionar Canal
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
